import React, { ReactNode } from "react";
import styled from "styled-components";
import { Container } from "react-bootstrap";

const ContainersWrapper = styled(Container)`
padding: 30px;
border-radius: 20px;
box-shadow: 1px 1px 3px #777777;
border: 1px solid lightgrey;
`;

interface Props {
    children?: ReactNode,
    className?: string
}

export default function CollaboratorsContainer(props: Props) {
    return <ContainersWrapper className={props.className}>
        {props.children}
    </ContainersWrapper>
}